import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { Snapshot } from '../Snapshot';
import { useAuthContext } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';

function SnapshotWrapper() {
    const { key } = useLocation();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    return (
        <>
            <DocumentTitle title="Snapshot" />
            <Snapshot user={user} refreshIdentifier={key} zoneContext={zoneContext}/>
        </>
    );
}

export default SnapshotWrapper;
